import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { IConfigurationState } from "redux/configuration/configuration.interface";
import Modal from "utils/hookedComponents/Modal";
import { useModal } from "utils/hookedComponents/Modal/core/modal.hook";
import ModalAlreadyParticipated from ".";

const AlreadyPlayedModal: FC = () => {
  const [isVisible, showModal, , reference] = useModal();
  const canPlayAgain = useSelector(
    (state: IConfigurationState) => state.game.canPlayAgain?.c
  );

  useEffect(() => {
    if (canPlayAgain === false) {
      showModal();
    }
    // showModal changes on every render in the shared modal hook.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canPlayAgain]);

  return isVisible ? (
    <Modal
      reference={reference}
      isVisible={isVisible}
      content={<ModalAlreadyParticipated />}
    />
  ) : null;
};

export default AlreadyPlayedModal;
